<!--
 * @Author: OnismYY
 * @Description: 顶部操作栏
-->
<template>
  <!--App Bar -->
  <v-app-bar :density="mdAndUp ? 'default' : 'compact'">
    <!-- search input mobil -->
    <div class="d-flex flex-fill align-center" v-if="showMobileSearch">
      <v-text-field
        color="primary"
        variant="solo"
        prepend-inner-icon="mdi-magnify"
        append-inner-icon="mdi-close"
        @click:append-inner="showMobileSearch = false"
        hide-details
        placeholder="搜索"
      ></v-text-field>
    </div>
    <div v-else class="px-2 d-flex align-center justify-space-between w-100">
      <logo />
      <!-- NavIcon -->
      <!-- <v-app-bar-nav-icon @click="customizeTheme.mainSidebar = !customizeTheme.mainSidebar"></v-app-bar-nav-icon> -->

      <!-- PC端搜索框 -->
      <!-- <div>
        <v-text-field
          v-if="mdAndUp"
          class="ml-2"
          style="width: 400px"
          color="primary"
          variant="solo"
          density="compact"
          prepend-inner-icon="mdi-magnify"
          hide-details
          placeholder="搜索"
        ></v-text-field>
      </div> -->

      <v-spacer></v-spacer>

      <div class="d-flex">
        <v-btn
          v-for="(btn, i) in btnList.filter((b) => b.show !== false)"
          :key="i"
          icon
          @click="router.push(btn.path)"
          :color="isActive(btn) ? 'success' : ''"
        >
          <v-icon :size="btn.size">{{ btn.icon }}</v-icon>
        </v-btn>

        <v-btn class="mx-2" icon @click="customizeTheme.mainSidebar = !customizeTheme.mainSidebar">
          <v-badge content="2" color="success" dot bordered>
            <v-avatar size="40">
              <v-img v-if="userStore.userInfo?.avatarUrl" :src="userStore.userInfo?.avatarUrl"></v-img>
              <v-img v-else src="@/assets/avatar/IDR_PROFILE_AVATAR_39@1x.png"></v-img>
            </v-avatar>
          </v-badge>
        </v-btn>

        <!-- 账户操作 -->
        <!-- <toolbar-user /> -->

        <!-- 移动端搜索按钮 -->
        <!-- <v-btn v-if="!mdAndUp" icon @click="showMobileSearch = true">
          <v-icon>mdi-magnify</v-icon>
        </v-btn> -->
        <!-- search input desktop -->

        <!-- 新增设备 -->
        <!-- <v-btn icon @click="bindDevice">
          <v-icon>mdi-plus-circle-outline</v-icon>
        </v-btn> -->

        <!-- 团队信息 -->
        <!-- <v-btn v-if="mdAndUp" icon>
          <v-badge dot color="success">
            <v-icon>mdi-account-multiple-outline</v-icon>
          </v-badge>
        </v-btn> -->

        <!-- 通知 -->
        <!-- <toolbar-notifications /> -->

        <!-- 切换语言 -->
        <!-- <language-switcher /> -->
      </div>
    </div>
  </v-app-bar>
</template>

<script setup>
import languageSwitcher from './language-switcher.vue'
import toolbarNotifications from './toolbar-notifications.vue'
import toolbarUser from './toolbar-user.vue'
import { useDisplay } from 'vuetify'
import { useCustomizeThemeStore } from '@/stores/customize-theme'
import { useUserStore } from '@/stores/user'

const { mdAndUp } = useDisplay()
const customizeTheme = useCustomizeThemeStore()
const router = useRouter()
const route = useRoute()
const userStore = useUserStore()

const showMobileSearch = ref(false)

const isShowHomeBtn = computed(() => {
  return route.path === '/home-page' ? false : true
})

const btnList = [
  {
    icon: 'mdi-water-outline',
    size: 30,
    path: '/water-ferti/water-ferti-center',
    root: 'water-ferti',
    match: (path) => path.startsWith('/water-ferti/water-ferti-center')
  },
  {
    icon: 'mdi-atom-variant',
    path: '/greenhouse/environmentalControl',
    root: 'greenhouse',
    match: (path) => path.startsWith('/greenhouse')
  },
  {
    icon: 'mdi-home-import-outline',
    size: 28,
    path: '/',
    root: 'home-page', // ✅ 关键
    match: (path) => path.startsWith('/home-page'),
    show: isShowHomeBtn
  }
]

const isActive = (btn) => {
  return btn.match?.(route.path)
}
const bindDevice = () => {
  router.push({
    name: 'scan-bind'
  })
}
</script>

<style scoped lang="scss"></style>
